/*
 * @Author: zys22 226208335@qq.com
 * @Date: 2026-10-12 15:00:44
 * @LastEditors: zys22 226208335@qq.com
 * @LastEditTime: 2026-10-12 15:13:30
 * @FilePath: /frasergen-weixin-web/src/store/payment_transfer.Store.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { makeAutoObservable } from "mobx"
import { http } from '@/utils'


const BASE_API = 'api/v1/wechat/'


class PaymentTransferStore{

  page = 0
  constructor() {
    makeAutoObservable(this)
  }
  // get_all_contract_transfer
  getAllPaymentTransfer  = async (search) =>{
    const res = await http.post(BASE_API+'get_all_contract_transfer',{page:this.page,limit:10,data_type:1,search:search})

    return res.data.data
  }

  setpage = (page)=> {
    this.page = page
  }

}

export default PaymentTransferStore
